import { render } from "./TheHeader.vue?vue&type=template&id=2183db38&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=2183db38&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2183db38"

export default script